export const uk = {
    error: 'Произошла ошибка, повторите попытку',
    'remove-confirm': 'Вы действительно хотите удалить {product}?',
    'remove-success': 'Продукт успешно удален'
};
